/** Product price audit history stores amounts in pence (e.g. 1005 = £10.05). */

export const penceToPounds = value => {
  if (value == null || value === '') return null
  const n = Number(value)
  if (!Number.isFinite(n)) return null
  return Math.round(n) / 100
}

/** Pounds amount as a fixed 2dp string, without a currency symbol. */
export const formatAuditPriceAmount = value => {
  const pounds = penceToPounds(value)
  if (pounds == null) return null
  return pounds.toFixed(2)
}

/** Human-readable audit price for admin UI (e.g. £10.05). */
export const formatAuditPrice = value => {
  const amount = formatAuditPriceAmount(value)
  if (amount == null) return '—'
  return `£${amount}`
}
